import { debounce } from 'throttle-debounce';

const tableSelector = '.article-text table:not(.messageTable)';
const wrapperClassName = 'article-tableWrapper';
const scrollerClassName = 'article-tableScroller';
const overflowingClassName = `${wrapperClassName}--overflowing`;
const fadeStartClassName = `${wrapperClassName}--fade-start`;
const fadeEndClassName = `${wrapperClassName}--fade-end`;
const hintClassName = 'article-tableWrapperHint';

let hintId = 0;
let captionId = 0;

const getScrollHint = () => {
    const language = document.documentElement.lang || '';

    if (language.toLowerCase().startsWith('en')) {
        return 'This table can be scrolled horizontally.';
    }

    return 'Denne tabellen kan rulles horisontalt.';
};

const ensureId = (element, prefix, currentId) => {
    if (element.id) {
        return currentId;
    }

    currentId += 1;
    element.id = `${prefix}-${currentId}`;

    return currentId;
};

const wrapTables = () => {
    const tables = document.querySelectorAll(tableSelector);

    tables.forEach(table => {
        if (table.parentElement && table.parentElement.classList.contains(wrapperClassName)) {
            return;
        }

        const wrapper = document.createElement('div');
        const scroller = document.createElement('div');
        const hint = document.createElement('span');

        wrapper.classList.add(wrapperClassName);
        scroller.classList.add(scrollerClassName);
        hint.classList.add('sr-only', hintClassName);

        hintId += 1;
        hint.id = `${hintClassName}-${hintId}`;
        hint.textContent = getScrollHint();

        const caption = table.querySelector('caption');
        if (caption) {
            captionId = ensureId(caption, 'article-table-caption', captionId);
            wrapper.setAttribute('aria-labelledby', caption.id);
        }

        wrapper.setAttribute('aria-describedby', hint.id);

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(hint);
        wrapper.appendChild(scroller);
        scroller.appendChild(table);
    });
};

const updateScrollableTable = (wrapper, scroller, table) => {
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    const isOverflowing = table.scrollWidth > scroller.clientWidth + 1;
    const canScrollLeft = scroller.scrollLeft > 1;
    const canScrollRight = scroller.scrollLeft < maxScrollLeft - 1;

    wrapper.classList.toggle(overflowingClassName, isOverflowing);
    wrapper.classList.toggle(fadeStartClassName, isOverflowing && canScrollLeft);
    wrapper.classList.toggle(fadeEndClassName, isOverflowing && canScrollRight);

    if (isOverflowing) {
        scroller.setAttribute('tabindex', '0');
        return;
    }

    scroller.removeAttribute('tabindex');
};

const updateScrollableTables = () => {
    const wrappers = document.querySelectorAll(`.${wrapperClassName}`);

    wrappers.forEach(wrapper => {
        const scroller = wrapper.querySelector(`.${scrollerClassName}`);
        const table = scroller ? scroller.querySelector('table') : null;

        if (!table || !scroller) {
            return;
        }

        if (!scroller.dataset.tableScrollBound) {
            scroller.addEventListener('scroll', () => updateScrollableTable(wrapper, scroller, table));
            scroller.dataset.tableScrollBound = 'true';
        }

        updateScrollableTable(wrapper, scroller, table);
    });
};

const init = () => {
    wrapTables();
    updateScrollableTables();
};

window.addEventListener('resize', debounce(200, updateScrollableTables));

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
    init();
}
